import { Component, OnInit, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { saveAs } from 'file-saver';

import { GoogleAnalyticsService } from './services/google-analytics.service';
import { SessionService } from './services/session.service';
import { UserService } from './services/user.service';
import { BlockUIService } from './services/blockui.service';
import { AlertService } from './services/alert.service';

import { Impresos } from './entities/impresos.entity';
import { Explotacion } from './entities/explotacion.entity';
import { Contrato } from './entities/contrato.entity';
import { ContratosUser } from './entities/ContratosUser.entity';
import { UsuarioOnline } from './entities/UsuarioOnline.entity';
import { Factura } from './entities/factura.entity';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [UserService, BlockUIService, AlertService]
})
export class AppComponent implements OnInit {
  public firstName!: string;
  public lastName!: string;
  public isAuthenicated: Boolean = false;
  public endDateTime!: string;
  public explotaciones: Explotacion[] = [];
  public blockUI!: Boolean;
  public user: ContratosUser = new ContratosUser;
  public currentYear: number = new Date().getFullYear();

  public currentRoute!: string;
  public title!: string;
  public version!: string;
  public webApiEndPoint!: string;
  public imagesDirectory: string;

  public condiciones!: string;
  public politica!: string;
  public pie!: string;
  public urlApi!: string;
  public isMain: boolean = false;
  public impresos: Impresos[] = [];
  public rowsOnPage = 6;
  public SortBy = 'Nombre';
  public SortOrder = 'asc';
  public ultimoImpreso: Impresos = new Impresos;
  public isEmmasa!: Boolean;

  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private sessionService: SessionService,
    private userService: UserService,
    private blockUIService: BlockUIService,
    public router: Router,
    private elementRef: ElementRef,
    private spinnerService: NgxSpinnerService
  ) {
    const native = this.elementRef.nativeElement;
    this.imagesDirectory = native.getAttribute('imagesDirectory');
    sessionService.apiServer = environment.urlApi; // this.webApiEndPoint;
    sessionService.TPVPage = environment.urlTPV;
    sessionService.version = environment.version;
  }

  public ngOnInit() {
    this.pie = environment.pie;
    this.sessionService.sessionEvent.subscribe((user: ContratosUser) => this.onAuthenication(user));
    if (localStorage.getItem('Oficina.WebApi.Angular4.Token') === '' || localStorage.getItem('Oficina.WebApi.Angular4.Token') === null) {
      this.router.navigate(['/public/login']);
    } else {
      this.userService.getExplotaciones().then((response: any) => this.cargarExplotaciones(response));
      this.blockUIService.blockUIEvent.subscribe((event: any) => this.blockUnBlockUI(event));
      this.blockUIService.blockUIEvent.emit({
        value: true
      });
      this.spinnerService.show();
      const usuarionew: UsuarioOnline = new UsuarioOnline();
      const user: ContratosUser = new ContratosUser();
      user.UsuarioOnline = usuarionew;
      this.userService.authenicate(user).then(
        (response: ContratosUser) => this.authenicateOnSuccess(response),
        (response: any) => this.authenicateOnError(response)
      );
    }
  }

  private blockUnBlockUI(event: { value: Boolean; }) {
    this.blockUI = event.value;
  }

  showHeaderB(): boolean {
    let valor = false;
    if (this.sessionService.contratos === undefined) {
      valor = true;
    }
    switch (this.router.url) {
      case ('/'):
      case ('/public/login'):
      case ('/public/register'):
      case ('/public/resetPassword'):
      case ('/public/contactpublic'):
        valor = true;
        break;
    }
    return valor;
  }

  private authenicateOnSuccess(response: ContratosUser) {
    this.blockUIService.blockUIEvent.emit({
      value: false
    });

    if (response.UsuarioOnline.ReturnStatus === false) {
      this.router.navigate(['/public/login']);
      return;
    }
    if (response.UsuarioOnline.IsAuthenicated === false) {
      this.router.navigate(['/public/login']);
      return;
    }
    const user: ContratosUser = new ContratosUser();
    const userOnline: UsuarioOnline = new UsuarioOnline();
    let contratos: Contrato[] = [];
    let facturas: Factura[] = [];
    userOnline.EMail = response.UsuarioOnline.EMail;
    userOnline.Nombre = response.UsuarioOnline.Nombre;
    userOnline.Login = response.UsuarioOnline.Login;
    userOnline.Telefono1 = response.UsuarioOnline.Telefono1;
    userOnline.Telefono2 = response.UsuarioOnline.Telefono2;
    userOnline.EFactura = response.UsuarioOnline.EFactura;
    userOnline.Explotacion = response.UsuarioOnline.Explotacion;
    contratos = response.Contratos;
    for (const i in contratos) {
      if (response.Contratos[i].Facturas.length > 0) {
        facturas = response.Contratos[i].Facturas;
        contratos[i].Facturas = facturas;
      }
    }
    user.UsuarioOnline = userOnline;
    user.Contratos = contratos;
    this.firstName = response.UsuarioOnline.Nombre;
    this.isAuthenicated = true;
    this.sessionService.authenicated(user, this.explotaciones);
    // this.spinnerService.hide();
    if (response != null && response.UsuarioOnline != null
      && response.UsuarioOnline.IsAuthenicated) {
      this.router.navigate(['/home/home']);
    } else {
      this.router.navigate(['/public/login']);
    }
  }

  private authenicateOnError(response: any) {
    this.router.navigate(['/public/login']);
    this.isAuthenicated = false;
    this.blockUIService.blockUIEvent.emit({
      value: false
    });
  }

  private onAuthenication(user: ContratosUser): void {
    this.firstName = user.UsuarioOnline.Nombre;
    this.isAuthenicated = true;
  }

  public logout() {
    this.firstName = '';
    this.lastName = '';
    this.isAuthenicated = false;
    this.sessionService.logout();
    if (typeof (Storage) !== 'undefined') {
      localStorage.setItem('Oficina.WebApi.Angular4.Token', '');
    }
    this.router.navigate(['public/login']);
  }

  getfooterStyle() {
    let footerStyle: string;
    if (this.router.url.startsWith('/home') || this.router.url.startsWith('/public/register')
      || this.router.url.startsWith('/public/contactpublic')) {
      footerStyle = 'site-footer';
    } else {
      footerStyle = 'site-footer footer-login';
    }
    if (this.router.url.startsWith('/home/home')) {
      footerStyle = 'site-footer footer-login';
    }
    if (this.sessionService.isAuthenicated === true && this.sessionService.contratoSelected !== undefined
      && this.sessionService.contratoSelected.Facturas !== undefined) {
      if (this.sessionService.contratoSelected.Facturas.length === 0 && this.router.url.startsWith('/home/consumofactura')) {
        footerStyle = 'site-footer footer-login';
      }
    }
    return footerStyle;
  }

  private cargarExplotaciones(response: Explotacion[]): void {
    this.explotaciones = response;
  }

  private appendGaTrackingCode() {
    try {
      const script = document.createElement('script');
      script.innerHTML = `
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
        ga('create', ' ` + environment.ganalytics + ` ', 'auto');    `;
      document.head.appendChild(script);
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }

  public onLoadGoogleCookies(storeGoogleCookies: any) {
    if (storeGoogleCookies) {
      this.appendGaTrackingCode();
      this.googleAnalyticsService.subscribeGoogle();
    }
  }

  // MODALS

  _showModalCondiciones = false;
  _showModalPolitica = false;
  _showModalImpresos = false;

  showModal() {
    return this._showModalCondiciones || this._showModalPolitica || this._showModalImpresos;
  }

  public closeModal() {
    this._showModalCondiciones = false;
    this._showModalPolitica = false;
    this._showModalImpresos = false;
  }

  public CargarPoliticaPrivacidad() {
    if (this.sessionService.datosExplotacion.CondicionesEnvio !== null) {
      this.politica = this.sessionService.datosExplotacion.CondicionesEnvio;
    } else {
      this.politica = '<p>Seleccione población</p>';
    }
    this._showModalPolitica = true;
  }

  public CargarCondicioneslegales() {
    if (this.sessionService.datosExplotacion.PoliticaEnvio !== null) {
      this.condiciones = this.sessionService.datosExplotacion.PoliticaEnvio;
    } else {
      this.condiciones = '<p>Seleccione población</p>';
    }
    this._showModalCondiciones = true;
  }

  public getImpresos() {
    if (this.sessionService.datosExplotacion.CondicionesEnvio != null) {
      this.userService.getImpresos(this.sessionService.datosExplotacion.Codigo)
        .then(
          (response: any) => this.getImpresosSuccess(response),
          (response: any) => this.getImpresosError(response)
        );
    } else {
      this.condiciones = '<p>Seleccione población</p>';
    }
    this._showModalImpresos = true;
  }

  private getImpresosSuccess(response: Impresos[]): void {
    this.impresos = response;
    this.updateDataSource();
  }

  private getImpresosError(response: any): void {
    this.impresos = [];
  }

  msgErrorDescarga = false;

  public DescargarFichero(impreso: Impresos) {
    this.spinnerService.show();
    this.msgErrorDescarga = false;
    this.ultimoImpreso = impreso;
    this.userService.descargaImpresos(this.sessionService.datosExplotacion.Codigo, impreso)
      .then(
        (response: any) => this.descargarImpresosSuccess(response),
        (response: any) => this.descargarImpresosError(response)
      );
  }

  private descargarImpresosSuccess(response: Blob): void {
    const fichero: Blob = response;
    const filename = this.ultimoImpreso.descripcion + '.pdf';
    this.spinnerService.hide();
    saveAs(fichero, filename);
  }

  private descargarImpresosError(response: any): void {
    this.spinnerService.hide();
    this.msgErrorDescarga = true;
    setTimeout(() => {
      this.msgErrorDescarga = false;
    }, 1000 * 10);
  }

  @ViewChild('myTable') table: any;

  private _colID = 'id';
  private displayedColumns = [
    'Nombre', 'PDF'
  ];

  data: Impresos[] = [];
  rows: any[] = [];
  isMobile = false;
  _tableFullscreen = false;
  _columnMode = ColumnMode.flex;

  @HostListener('window:resize', ['$event'])
  onResize(event = null) {
    const windowWidth = event !== null ? event.target.innerWidth : window.innerWidth;
    this.isMobile = windowWidth < 800;
  }

  private updateDataSource() {
    this.data = this.impresos;
    if (this.displayedColumns.length > 0) {
      let i = 0;
      this.rows = [];
      const _dataLength = this.data.length;
      while (i < _dataLength) {
        let item = {};
        item[this._colID] = this.data[i]['id'];
        this.displayedColumns.forEach((dc: string) => {
          item[dc.toLowerCase()] = this.getDataValue(this.data[i][dc]);
        });
        this.rows.push(item);
        i++;
      }
    }
  }

  private getDataValue(dataItem: any) {
    return dataItem === undefined || dataItem === null ? '' : dataItem;
  }

  getRowItem(row: any) {
    const id = row[this._colID];
    const currentItem = this.data.find(d => d.id === id);
    return currentItem;
  }
}
